/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ILabelStyles } from '@fluentui/react/lib/Label';
import { IStackStyles } from '@fluentui/react/lib/Stack';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';

import { FontSizes } from '../../../styles/teams';

export const getStackStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            height: '100%',
            position: 'relative',
            selectors: {
                '&>div:not(.loading-container)': {
                    padding: '1.25rem 2.875rem',
                },
                '&>div': {
                    width: '100%',
                    height: '100%',
                },
            },
        },
    };
};

export const getInnerStackStyles = (isVisible: boolean): Partial<IStackStyles> => {
    return {
        root: { position: 'absolute', overflowY: 'auto', display: isVisible ? undefined : 'none' },
    };
};

export const getTitleStyles = (theme: ITheme): Partial<ILabelStyles> => {
    return {
        root: {
            color: theme.palette.black,
            fontSize: FontSizes.size18,
            fontWeight: FontWeights.bold,
            height: '1.5rem',
            lineHeight: '1.5rem',
            padding: 0,
        },
    };
};

export const getDescriptionStyles = (theme: ITheme): Partial<ILabelStyles> => {
    return {
        root: {
            color: theme.palette.neutralDark,
            padding: 0,
            fontWeight: 'normal',
            marginBottom: '1.5rem',
        },
    };
};
